"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var LockTypeEnum_1 = require("../../product/model/LockTypeEnum");
/**
 * @author PKr
 */


var ReplenishmentPromoManagementUpdateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReplenishmentPromoManagementUpdateDTO, _DomainObject_1$Domai);

  /**
   * DTO used for price stickers report
   *
   * @param windowItemId
   * @param supplierAgreementId
   * @param returnable
   * @param returnableCondition
   * @param endDateOfReturn
   * @param ignoreForTraining
   * @param logisticComment
   * @param obligatoryToBuy
   * @param maximalVolume
   * @param minimalVolume
   * @param justInTime
   * @param lockType
   * @param selloutSales
   * @param directDelivery
   * @param directDeliverySites
   * @param distrModelId
   * @param distributionModelDays
   */
  function ReplenishmentPromoManagementUpdateDTO(windowItemId, supplierAgreementId, returnable, returnableCondition, endDateOfReturn, ignoreForTraining, logisticComment, justInTime, lockType, selloutSales, directDelivery, directDeliverySites, distrModelId, distributionModelDays, maximalVolume, minimalVolume, obligatoryToBuy) {
    var _this;

    _classCallCheck(this, ReplenishmentPromoManagementUpdateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentPromoManagementUpdateDTO).call(this));
    _this.windowItemId = windowItemId;
    _this.supplierAgreementId = supplierAgreementId;
    _this.returnable = returnable;
    _this.returnableCondition = returnableCondition;
    _this.endDateOfReturn = endDateOfReturn;
    _this.ignoreForTraining = ignoreForTraining;
    _this.logisticComment = logisticComment;
    _this.justInTime = justInTime;
    _this.lockType = lockType;
    _this.selloutSales = selloutSales;
    _this.directDelivery = directDelivery;
    _this.directDeliverySites = directDeliverySites;
    _this.distrModelId = distrModelId;
    _this.distributionModelDays = distributionModelDays;
    _this.maximalVolume = maximalVolume;
    _this.minimalVolume = minimalVolume;
    _this.obligatoryToBuy = obligatoryToBuy;
    return _this;
  }

  return ReplenishmentPromoManagementUpdateDTO;
}(DomainObject_1.DomainObject);

exports.ReplenishmentPromoManagementUpdateDTO = ReplenishmentPromoManagementUpdateDTO;

ReplenishmentPromoManagementUpdateDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReplenishmentPromoManagementUpdateDTO.name);
  return {
    windowItemId: builder.str('windowItemId'),
    supplierAgreementId: builder.str('supplierAgreementId'),
    returnable: builder.opt(builder.bool('returnable')),
    returnableCondition: builder.opt(builder.str('returnableCondition')),
    endDateOfReturn: builder.opt(builder.date('endDateOfReturn', DateParser_1.DateParser.ISO_PATTERN)),
    ignoreForTraining: builder.opt(builder.bool('ignoreForTraining')),
    logisticComment: builder.opt(builder.str('logisticComment')),
    justInTime: builder.opt(builder.bool('justInTime')),
    lockType: builder.opt(builder.senum('lockType', LockTypeEnum_1.LockTypeEnum, CodebookLookupSequence_1.CodebookLookupSequence.LockType)),
    selloutSales: builder.opt(builder.bool('selloutSales')),
    directDelivery: builder.opt(builder.bool('directDelivery')),
    directDeliverySites: builder.opt(builder.str('directDeliverySites')),
    distrModelId: builder.opt(builder.str('distrModelId')),
    distributionModelDays: builder.opt(builder.num('distributionModelDays')),
    maximalVolume: builder.opt(builder.bigNum('maximalVolume')),
    minimalVolume: builder.opt(builder.bigNum('minimalVolume')),
    obligatoryToBuy: builder.opt(builder.bool('obligatoryToBuy'))
  };
}();